"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageUploadFileSettings = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsUploadFileSettings = require("./DmsUploadFileSettings");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageUploadFileSettings component renders a page for managing upload file settings.
 * It includes a navigation route for home, settings, and upload file settings.
 */
const DmsPageUploadFileSettings = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Upload File Settings"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("UploadFileSettings").d("Upload File Settings"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsUploadFileSettings.DmsUploadFileSettings, null))));
};
exports.DmsPageUploadFileSettings = DmsPageUploadFileSettings;